import React, { useEffect, useState } from "react";
import { Document, Page, Text, View, StyleSheet, Image, pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import logoImgText from '../../Img/100BILLION_TECH_name.png';
import logoImg from '../../Img/100BILLION_ICON.png';
import axios from "axios";


const styles = StyleSheet.create({
    summaryRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 4,
        fontSize: 12,
        paddingHorizontal: 10
    },
    summaryLabel: {
        fontWeight: "bold",
        fontSize: 12
    },
    summaryValue: {
        fontSize: 12
    },
    page: { padding: 20, backgroundColor: "#f9f9f9" },
    header: {
        flexDirection: "row", justifyContent: "space-between", alignItems: "center",
        marginBottom: 12, padding: 8, borderBottomWidth: 1, borderBottomColor: "#ddd",
        backgroundColor: "#d1dffa", gap: "15px"
    },
    headerP: { fontSize: 12, color: "#444", marginTop: "5px" },
    flex: { flex: 1 },
    headerRight: { textAlign: "right" },
    displayLogo: { display: "flex", flexDirection: "row", alignItems: "center" },
    logo1: { width: 40, marginRight: 5, objectFit: "contain" },
    logo2: { width: 100, objectFit: "contain" },
    invoiceInfo: {
        flexDirection: "row", justifyContent: "space-between",
        fontSize: 14, marginBottom: 12, marginTop: 8
    },
    invoiceFlex: { flex: 1, maxWidth: "50%" },
    invoiceFlexHeading: { fontSize: 16, fontWeight: "bold", marginBottom: 5 },
    invoiceInfoText: { marginBottom: 3, fontSize: 14 },
    row: {
        flexDirection: "row", borderBottomWidth: 1,
        paddingVertical: 4, borderBottomColor: "#ddd",
        fontSize: 14, textAlign: "left"
    },
    cell: { flex: 1, textAlign: "center", fontSize: 12 },
    cellFlex2: { flex: 2, textAlign: "center", fontSize: 12 },
    invoiceTotal: {
        textAlign: "right", fontSize: 16, fontWeight: "bold",
        marginBottom: 12, marginTop: 8, color: "#111"
    },
    invoiceNotesHeading: { fontSize: 14, marginTop: 8, marginBottom: 6, fontWeight: "600" },
    invoiceNotesLi: { fontSize: 12, color: "#555" }
});

const InvoiceDocument = ({ invoice, profile }) => {
    console.log(invoice);
    // const [profile, setProfile] = useState({});
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const url = process.env.REACT_APP_LINK
    let items = [];
    try {
        items = typeof invoice.items === "string" ? JSON.parse(invoice.items) : invoice.items;
        if (typeof items === "string") {
            items = JSON.parse(items);
        }
    } catch (error) {
        console.error("Failed to parse invoice.items:", error);
        items = [];
    }

    // const fetchData = async () => {
    //     try {
    //         const response = await axios.get(`${url}/auth/single/${isLoggedIn.user_id}`);
    //         setProfile(response.data);
    //     } catch (error) {
    //         console.error('Error fetching location:', error);
    //     }
    // }

    
    const totalAmount = invoice.grand_total;

    // useEffect(() => {
    //     fetchData();
    // }, [])

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <View style={styles.flex}>
                        <View style={styles.displayLogo}>
                            <Image src={logoImg} style={styles.logo1} />
                            <Image src={logoImgText} style={styles.logo2} />
                        </View>
                        <Text style={styles.headerP}>{profile.address}</Text>
                    </View>
                    <View style={[styles.flex, styles.headerRight]}>
                        <Text style={styles.headerP}>Invoice Date: {invoice.invoice_date}</Text>
                        <Text style={styles.headerP}>Invoice #: {invoice.invoice_number}</Text>
                        <Text style={styles.headerP}>Order #: {invoice.order_number}</Text>
                        <Text style={styles.headerP}>Phone No.: +91 {profile.mobile}</Text>
                        <Text style={styles.headerP}>Mail ID: {profile.email}</Text>
                    </View>
                </View>

                <View style={styles.invoiceInfo}>
                    <View style={styles.invoiceFlex}>
                        <Text style={styles.invoiceFlexHeading}>Billing To:</Text>
                        <Text style={styles.invoiceInfoText}>{invoice.customer_name}</Text>
                    </View>
                    <View style={styles.invoiceFlex}>
                        <Text style={styles.invoiceFlexHeading}>Due Date:</Text>
                        <Text style={styles.invoiceInfoText}>{invoice.due_date}</Text>
                    </View>
                </View>

                <View style={[styles.row, { backgroundColor: "#d1dffa" }]}>
                    <Text style={styles.cellFlex2}>Item</Text>
                    <Text style={styles.cell}>Qty</Text>
                    <Text style={styles.cell}>Rate</Text>
                    <Text style={styles.cell}>Discount</Text>
                    <Text style={styles.cell}>Tax</Text>
                    <Text style={styles.cell}>Amount</Text>
                </View>

                {items.map((item, i) => (
                    <View key={i} style={styles.row}>
                        <Text style={styles.cellFlex2}>{item.item}</Text>
                        <Text style={styles.cell}>{item.quantity}</Text>
                        <Text style={styles.cell}>Rs{item.rate}</Text>
                        <Text style={styles.cell}>{item.discount}%</Text>
                        <Text style={styles.cell}>{item.tax}%</Text>
                        <Text style={styles.cell}>Rs{item.amount}</Text>
                    </View>
                ))}

                {/* Totals Breakdown */}
                <View style={{
                    borderWidth: 1,
                    borderColor: "#ccc",
                    borderRadius: 6,
                    padding: 10,
                    marginTop: 12,
                    backgroundColor: "#f2f6ff"
                }}>
                    <Text style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        marginBottom: 8,
                        textAlign: "center",
                        color: "#003366"
                    }}>
                        Invoice Summary
                    </Text>

                    {[
                        { label: "Subtotal", value: invoice.subtotal },
                        { label: "Discount Amount", value: invoice.discount_amount },
                        { label: "Advance Payment", value: invoice.advance_payment },
                        { label: "Tax", value: invoice.tax },
                        { label: "Shipping", value: invoice.shipping },
                        { label: "Pending", value: invoice.pending },
                    ].map((item, idx) => (
                        <View
                            key={idx}
                            style={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginBottom: 4,
                                borderBottomWidth: 0.5,
                                borderBottomColor: "#ddd",
                                paddingBottom: 2
                            }}
                        >
                            <Text style={{ fontSize: 12, color: "#333", fontWeight: "600" }}>{item.label}</Text>
                            <Text style={{ fontSize: 12, color: "#222" }}>₹{item.value.toFixed(2)}</Text>
                        </View>
                    ))}
                </View>

                <View style={{
                    marginTop: 10,
                    padding: 10,
                    backgroundColor: "#003366",
                    borderRadius: 6
                }}>
                    <Text style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        color: "white",
                        textAlign: "right"
                    }}>
                        Grand Total: Rs{invoice.grand_total.toFixed(2)}
                    </Text>
                </View>


                <View>
                    <Text style={styles.invoiceNotesHeading}>Customer Note</Text>
                    <Text style={styles.invoiceNotesLi}>{invoice.customer_note || "No additional notes"}</Text>
                </View>
            </Page>
        </Document>
    );
};

const InvoicePdf = () => {
    const { order_number } = useParams();
    const [invoiceData, setInvoiceData] = useState(null);
    const url = process.env.REACT_APP_LINK
    useEffect(() => {
        const fetchInvoice = async () => {
            try {
                const res = await fetch(`${url}/newinvoice/all`);
                const data = await res.json();
                const match = data.find(inv => String(inv.order_number) === String(order_number));
                if (match) {
                    setInvoiceData(match);
                } else {
                    alert("Invoice not found.");
                }
            } catch (error) {
                console.error("Error fetching invoice:", error);
            }
        };

        fetchInvoice();
    }, [order_number]);

    useEffect(() => {
        if (invoiceData) {
            const generate = async () => {
                const blob = await pdf(<InvoiceDocument invoice={invoiceData} />).toBlob();
                saveAs(blob, `Invoice_${invoiceData.invoice_number}.pdf`);
            };
            generate();
        }
    }, [invoiceData]);

    return null;
};

export default InvoicePdf;


